import { useState } from "react";
import getNameByID from "../../../../../functions/getNameByID";
import { Update_To_MongoDB_Push_To_Array_By_ID } from "../../../../api/Update_To_MongoDB_Push_To_Array_By_ID";
import { StaffuseAuth } from "../../../../security/StaffuseAuth";

function SEFNotes({ Attendee, Staff, setAttendee }) {
  const { logout } = StaffuseAuth();

  const [textAreaValue, setTextAreaValue] = useState("");
  const handleTextAreaChange = (e) => {
    setTextAreaValue(e.target.value);
  };

  function handleAddNote(e) {
    let newDoc = {
      DateTime: new Date().toISOString(),
      Note: textAreaValue,
      Staff_ID: localStorage.getItem("_id"),
    };
    // Check if the Attendee has notes and if it is an array
    if (Attendee && Attendee.Notes && Array.isArray(Attendee.Notes)) {
      const updatedNotes = [...Attendee.Notes, newDoc];
      setAttendee({ ...Attendee, Notes: updatedNotes });
      setTextAreaValue("");
    }
    // If the Attendee does not have notes
    else {
      setAttendee({
        ...Attendee,
        Notes: [newDoc],
      });
      setTextAreaValue("");
    }
    Update_To_MongoDB_Push_To_Array_By_ID(
      "Registers_2025",
      "All",
      newDoc,
      "Notes",
      Attendee._id,
      logout
    );
  }

  return (
    <>
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Note</th>
              <th>User</th>
            </tr>
          </thead>
          <tbody>
            {Attendee.Notes ? (
              Attendee.Notes.map((row, index) => (
                <tr key={index}>
                  <td>{row.Note}</td>
                  <td>{row.DateTime.substr(0, 10)}</td>
                  <td>{getNameByID(Staff, row.Staff_ID, "Username")}</td>
                </tr>
              ))
            ) : (
              <></>
            )}
          </tbody>
        </table>
        <div style={{ width: "100%" }}>
          <textarea
            className="text-area"
            value={textAreaValue}
            onChange={handleTextAreaChange}
          />
          <button onClick={handleAddNote}>Add Note</button>
        </div>
      </div>
    </>
  );
}

export default SEFNotes;
